module.exports = __webpack_public_path__ + "img/platformValue.dcb1913d.png";